<template>
  <SeoBlogArticle :content="$t('seoArticleOpenGraphPersonalizacao')" :faq="faq"/>
</template>
<script>
import SeoBlogArticle from "../fragments/SeoBlogArticle.vue";
import faq from "../../../../public/seo-faq/open-graph-personalizacao-de-links.json";
export default {
  name: 'ArticleOpenGraphPersonalizacao',
  components: { SeoBlogArticle },
  data: () => ({ faq: faq.items }),
}
</script>
